import {isString} from '@gl/lit/utils/index.js';

export enum AudienceScheduleStartTypeEnum {
  NOW = 'Now',
  SCHEDULE = 'Schedule',
}

export const AUDIENCE_SCHEDULE_START_TYPES = Object.values(
  AudienceScheduleStartTypeEnum
);

export const isAudienceScheduleStartType = (
  value: unknown
): value is AudienceScheduleStartTypeEnum => {
  return (
    isString(value) &&
    AUDIENCE_SCHEDULE_START_TYPES.includes(
      value as AudienceScheduleStartTypeEnum
    )
  );
};

export enum AudienceScheduleEndTypeEnum {
  NEVER = 'Never',
  SCHEDULE = 'Schedule',
}

export const AUDIENCE_SCHEDULE_END_TYPES = Object.values(
  AudienceScheduleEndTypeEnum
);

export const isAudienceScheduleEndType = (
  value: unknown
): value is AudienceScheduleEndTypeEnum => {
  return (
    isString(value) &&
    AUDIENCE_SCHEDULE_END_TYPES.includes(value as AudienceScheduleEndTypeEnum)
  );
};

export enum AudienceFrequencyEnum {
  FIFTEEN_MINUTES = 'fifteen minutes',
  THIRTY_MINUTES = 'thirty minutes',
  HOURLY = 'hourly',
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  REALTIME = 'realtime',
}

export const audienceSyncFrequencyEnumLabels: Record<
  AudienceFrequencyEnum,
  string
> = {
  [AudienceFrequencyEnum.FIFTEEN_MINUTES]: '15 Minutes',
  [AudienceFrequencyEnum.THIRTY_MINUTES]: '30 Minutes',
  [AudienceFrequencyEnum.HOURLY]: 'Hourly',
  [AudienceFrequencyEnum.DAILY]: 'Daily',
  [AudienceFrequencyEnum.WEEKLY]: 'Weekly',
  [AudienceFrequencyEnum.MONTHLY]: 'Monthly',
  [AudienceFrequencyEnum.REALTIME]: 'Realtime',
};

export const isAudienceFrequency = (
  value: unknown
): value is AudienceFrequencyEnum => {
  return (
    isString(value) &&
    Object.values<string>(AudienceFrequencyEnum).includes(value)
  );
};
